import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DynamicTableService {

  private datasource = new BehaviorSubject([]);
  private checkItems = new BehaviorSubject(null);

  currentValue = this.datasource.asObservable();
  checkValue = this.checkItems.asObservable();


  constructor() { }

  refresh(data: any) {
    this.datasource.next(data)
  }

  checkedOptions(data: any){
    this.checkItems.next(data);
  }

}
